import * as React from 'react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import * as Styled from './styled';
import { AppBar, Tab, Tabs } from '@material-ui/core';
import ShortCuts from './ShortCuts';

enum USER_INFORMATION_VIEW_TABS {
    HOTKEYS
}

const UserInfromationContainer: React.FC = () => {
    const [currentTab, setCurrentTab] = useState<number>();
    const { t } = useTranslation(['settings']);

    useEffect(() => {
        setCurrentTab(USER_INFORMATION_VIEW_TABS.HOTKEYS);
    }, []);

    const handleTabChange = (e: React.ChangeEvent, newValue: number) => {
        setCurrentTab(newValue);
    }

    return (
        <Styled.Container>
            <AppBar position="static" color="default" style={{borderRadius: '4px'}}>
                <Tabs
                    value={currentTab}
                    onChange={handleTabChange}
                    indicatorColor="secondary"
                    variant="fullWidth"
                    centered={true}
                >
                    <Tab
                        value={USER_INFORMATION_VIEW_TABS.HOTKEYS} 
                        label={t('tab.user_information.tab.shortcuts.title')}
                    />
                </Tabs>
            </AppBar>
            {currentTab === USER_INFORMATION_VIEW_TABS.HOTKEYS && <ShortCuts/>}
        </Styled.Container>
    );
}

export default UserInfromationContainer;